import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import config from './config';
import { environment } from 'environments/environment';
import { appSetting } from "config/appSettings";

@Injectable()
export class ServerSyncService {

    isOnline: boolean = false;
    // server time offset in ms
    serverTimeOffset: number = 0;
    serverTimeOffsetLSKey = `${appSetting.localStorage.foc}-serverTimeSyncOffset`;
    
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private networkService: NetwordDetectionService
    ) {

        // running the constructor's code only in desktop mode
        // running this code in web app will creating error as 
        // definition of BroadcastChannel is not present in window's scope
        // and in strict mode it stops the app to load in iOS devices
        if(environment.isDesktopApp){

            this.networkService
                .isOnline()
                .then(res => {
                    this.isOnline = res;
                    this.calcServerTimeOffset();
                })
                .catch(err => {
                    this.isOnline = false;
                    this.calcServerTimeOffset();
                });
        }
    }

    public async calcServerTimeOffset(){
        // calculate server time offset only if the app is launched in online mode
        if(this.isOnline){
            let t0 = Date.now();        // Request Start Time
            this.http
                .get(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl()  + "server-sync-time", {observe: 'response'})
                .subscribe(async (res) => {
                    let t3 = Date.now();    // Request Complete Time
                    let t1 = (new Date(res.headers.get('Date'))).getTime(); // time at which request reached the server
                    let t2 = res.body['t2'];    // time at which response was sent from the server

                    this.serverTimeOffset = Math.ceil(((t1-t0) + (t2-t3))/2)
                    localStorage.setItem(this.serverTimeOffsetLSKey, ""+this.serverTimeOffset);
                    
                    await DLS_IPCCallers.SET_SERVER_SYNC_TIME({offset: this.serverTimeOffset});
                })
        }else{
            let offset = localStorage.getItem(this.serverTimeOffsetLSKey);
            if((offset != null) && !isNaN(+offset)){
                this.serverTimeOffset = +offset;
            }else{
                this.serverTimeOffset = 0;
            }

            await DLS_IPCCallers.SET_SERVER_SYNC_TIME({offset: this.serverTimeOffset});
        }
    }

    public getServerTimeOffset() {
        return this.serverTimeOffset;
    }


}